import { render } from "./EmployeesList.vue?vue&type=template&id=cb4f301a"
import script from "./EmployeesList.vue?vue&type=script&lang=js"
export * from "./EmployeesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__